import template from './land-electricity.jade';
import items from '../../../enums/land-communications-location';

export default angular
  .module('cian.addForm.aboutObjectLandElectricity', [])
  .directive('cianAfAboutObjectLandElectricity', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      'deviceService',
      function (deviceService) {
        this.isMobile = deviceService.isMobile;
        this.items = items;
        this.ad.electricity = this.ad.electricity || {};

        const isOnTypes = ['border', 'location'];
        this.isOn = () => isOnTypes.includes(this.ad.electricity.locationType);

        this.isOnPossibleConnect = () => this.ad.electricity.locationType === 'no';
      },
    ],
    controllerAs: 'landElectricity',
    template,
  })).name;
